/**
 * @fileoverview Azure Function Health Constants
 * @description Defines dashboard environments, schedules, filters, and persistence keys.
 */

// Created or modified by CoPilot AI Agent
export const HEALTH_ENVIRONMENTS = ['TEST', 'QA', 'PROD'];
export const DEFAULT_DOMAIN = 'Crew Tools';
export const DEFAULT_POD = 'Transformers';
export const DEFAULT_DOMAIN_POD_MAP = {
  [DEFAULT_DOMAIN]: [
    DEFAULT_POD,
    'Polaris',
    'Compliance Cruisers',
    'Crews Control',
    'Flight Club',
    'Thunderbirds',
  ],
};

export const DASHBOARD_FILTERS = {
  FAVORITES: 'favorites',
  ALL: 'all',
  FULLY_COMPLIANT: 'fully-compliant',
  PARTIAL_COMPLIANT: 'partial-compliant',
  NOT_COMPLIANT: 'not-compliant',
  HEALTHY: 'healthy',
  UNHEALTHY: 'unhealthy',
  SKIPPED: 'skipped',
};

export const PROBE_KINDS = {
  HEAD: 'head',
  HEALTH: 'health',
};

export const PROBE_REFRESH_INTERVALS = {
  [PROBE_KINDS.HEAD]: 5 * 60 * 1000,
  [PROBE_KINDS.HEALTH]: 60 * 60 * 1000,
};

export const MAX_INITIAL_PROBE_CONCURRENCY = 3;
export const INITIAL_PROBE_STAGGER_MS = 250;

export const HEALTH_STORAGE_KEYS = {
  FAILURE_NOTICES: 'azureFunctionHealth.failureNotices.v2',
  SELECTED_ENVIRONMENTS: 'azureFunctionHealth.selectedEnvironments.v2',
  LEGACY_FAILURE_NOTICES: 'azureFunctionHealth.failureNotices.v1',
  LEGACY_SELECTED_ENVIRONMENTS: 'azureFunctionHealth.selectedEnvironments.v1',
};